import React from 'react'

function ManualHeader({ data }: any) {
    return (data &&
        <div className="ManualHeader-Background">
            <div className="container">
                <h1 className="ManualHeader-h1">{data.title}</h1>
                <div dangerouslySetInnerHTML={{ __html: data.description }} />
            </div>
        </div>
    )
}

export default ManualHeader
